export default {
"defaultCapacity":"Default delivery capacity",
"setDatesWhenAssigning":"Set dates when assigning",
"schedulingChoice": "When will this workshop run?",
"scheduleNow": "Schedule now",
"datesWhenAssigning": "Dates set when assigning",
"reusableDefaultsHelp": "These are delivery defaults, not a scheduled booking. Dates and availability are confirmed when assigning staff.",
"defaultDuration": "Default duration (minutes)",

  register: {"editParticipant":"Edit attendance for {name}","replacement":"Replacement attendance status","saveChanges":"Save changes","otherStatusesStart":"Other attendance statuses become available when the session starts.","accessDenied": "You no longer have access to this register. Contact your club administrator or refresh after access is restored.", "signIn": "Your session has expired. Sign in again, then refresh the register.", "checking": "Checking access and refreshing the register…", "savedNeutral": "Your change was saved.","deliverySaved":"Session marked as delivered.","deliveryFailed":"Delivery could not be saved. Retry when available.","title": "Attendance register", "back": "Back to session", "counts": "Saved attendance counts", "search": "Search people", "filter": "Attendance status", "noMatching": "No people match these filters.", "empty": "No confirmed participants are entitled to this session.", "choose": "Choose attendance", "correct": "Edit attendance", "reason": "Reason for change", "savedStatus": "Saved status", "unsaved": "Unsaved selection", "confirm": "Confirm attendance", "saving": "Saving…", "saved": "Attendance saved.", "failed": "Attendance could not be saved. Your selection is retained.", "savedRefreshFailed": "Saved successfully. The refreshed register is unavailable. Do not submit again.", "unavailable": "The register is unavailable. Retry the read to recover.", "countsStale": "Counts show the last successful read and are awaiting confirmation. Editing is unavailable until the register is refreshed.", "refresh": "Refresh register", "readOnly": "Attendance recording is unavailable with your current permissions.", "cancelled": "Recording is unavailable because this session is cancelled.", "deliveryHelp": "Marking delivery records that the session was delivered. It does not record attendance, assessed completion or Academy accreditation."},
  attendanceReport: {"rankingTable": "View rankings as a table", "person": "Person", "recordedRate": "Recorded attendance rate", "sessionCount": "Eligible sessions","registerUnavailable":"Session register unavailable with your destination permissions.","title": "Attendance", "intro": "Recorded attendance for entitled participants in your reporting scope.", "loading": "Loading attendance…", "failed": "Attendance could not be loaded. No totals are confirmed.", "restricted": "Attendance reporting is unavailable with your current permissions.", "unavailable": "Attendance sources are unavailable. No totals are confirmed.", "retry": "Retry", "empty": "No eligible sessions in this period", "emptyHelp": "Try another reporting period or adjust the filters. Attendance is never inferred from enrolment totals.", "noRate": "No recorded rate", "rate": "Recorded attendance rate · {attended} attended / {denominator} recorded", "incomplete": "{count} participant-session records have no saved attendance status. These are not recorded absences.", "trend": "Attendance by session date", "date": "Session date", "table": "View trend as a table", "attended": "Attended", "rankings": "Attendance rankings", "mostAttended": "Most attended", "mostAbsent": "Most recorded absences", "endedOnly": "Rankings include only sessions whose scheduled end has passed.", "noRankings": "No matching saved records for ended sessions.", "samples": "{count} eligible sessions", "definitions": "How attendance is counted", "metrics": "Present and Late count as attended. Only a saved Absent record counts as a recorded absence. The recorded attendance rate is (Present + Late) / (Present + Late + Absent). Excused and Not recorded are separate and excluded from that denominator. No percentage is shown when the denominator is zero.", "scope": "Session dates use the club timezone. Only selected, entitled occurrences count, once per canonical person and session using the latest saved status. Corrections replace the current result. Cancelled sessions and places cancelled before the session are excluded. Closed and archived programmes retain historical attendance. Early check-ins do not enter rankings until the scheduled end has passed. Attendance and delivery do not imply assessed completion or accreditation.", "detailIntro": "Matching people and session records. Access is checked again when opening this panel and the session register.", "register": "Open session register", "noDetails": "No matching records remain in your current scope.", "records": "{count} records", "pages": "Attendance detail pages", "previous": "Previous", "next": "Next", "page": "Page {page} of {total}"},
  run: {"currencyUnavailable":"Paid · Original currency unavailable","changeInstructor":"Change instructor","editCapacity":"Edit maximum attendees","confirmed":"Confirmed","held":"Held","viewSessions":"View all {count} sessions","search":"Search participants","noMatching":"No matching participants.","rosterUnavailable":"Participants are unavailable. Retry to refresh.","choose": "Workshop runs", "unknown": "Unavailable", "available": "Available places", "capacityUsed": "Capacity in use", "about": "About this workshop", "noDescription": "No description is available.", "next": "Next session", "noUpcoming": "No upcoming session.", "settings": "Run settings", "management": "Run management", "addSessions": "Create additional sessions", "booking": "Booking", "created": "Enrolment created", "participantActions": "Participant actions"},
 viewWorkshop: "View Workshop",
  dashboard: {"filters":"Reporting filters","scopeDetails":"Reporting information","activityEmpty":"Your Academy activity will appear here","activityEmptyHelp":"Confirmed enrolments populate this overview. There are no results in your current reporting scope and period.","browse":"Browse workshops","noActive":"No active enrolments right now","periodHint":"Try another reporting period to view confirmed enrolments.","noMatching":"No matching enrolments","clearFilters":"Clear filters","onlineBadge":"E-learning participation unavailable","sourceUnavailable":"Reporting sources are currently unavailable. Your permitted Academy destinations remain available.",
    "staffUnavailableShort": "Staff unavailable",
    "members": "Members",
    "resultsOne": "1 active enrolment",
    "unknownOne": "1 active enrolment has no authoritative confirmation timestamp and cannot be included in confirmation history.",
    "workshopLabel": "Workshop",
    "campLabel": "Camp",

    "notAvailable": "Not yet available",
    "staffUnavailable": "Staff reporting is temporarily unavailable. These figures include Members only. Retry to refresh all sources.",
    "title": "Academy overview",
    "subtitle": "Current participation and confirmed enrolment history across your club.",
    "period": "Reporting period",
    "month": "This month",
    "last_month": "Last month",
    "quarter": "Last 3 months",
    "learners": "Active learners",
    "programmes": "Active programmes",
    "enrolments": "Confirmed enrolments in period",
    "sessions": "Sessions this week",
    "learnersHelp": "Distinct people with a confirmed enrolment and a current or future selected session. Member takes precedence for people with both roles.",
    "programmesHelp": "Distinct live published offerings with a current or future scheduled session, including offerings with no enrolments. Learner filters limit this to matching participation. Versions and reusable definitions are not counted.",
    "enrolmentsHelp": "Gross confirmed enrolments in this period, including later cancellations and finished, closed or archived learning. Each attempt counts once; request/order dates are not confirmation evidence.",
    "sessionsHelp": "Distinct scheduled sessions this club-local week selected by participants in your reporting scope.",
    "breakdown": "{members} Members · {staff} Staff",
    "shortcuts": "Academy destinations",
    "loading": "Loading Academy overview…",
    "error": "The overview could not be loaded. Your Academy destinations are still available.",
    "retry": "Retry",
    "unavailable": "Reporting is unavailable for your current permissions. Use your permitted Academy destinations above.",
    "onlineUnavailable": "E-learning participation: Not yet available. Published references and assignments do not establish online enrolment or evaluated completion.",
    "scope": "Current participation and historical confirmations use your authorised Member/Staff scope and the same filters.",
    "unknown": "{count} active enrolments have no authoritative confirmation timestamp and cannot be included in confirmation history.",
    "trend": "Enrolment confirmations over time",
    "types": "Active enrolments by type",
    "partial": "* Partial week within the selected reporting period. Weeks start on Monday in the club timezone.",
    "chartText": "View weekly figures as a table",
    "week": "Week starting",
    "member": "Member",
    "staff": "Staff",
    "workshop": "Workshops",
    "online": "E-learning",
    "camp": "Camps",
    "active": "Active enrolments",
    "search": "Search learner or course",
    "learnerType": "Learner type",
    "format": "Learning format",
    "allPeople": "Members & Staff",
    "allFormats": "All formats",
    "noEnrolments": "No recorded confirmations in this period.",
    "empty": "No active enrolments in your reporting scope.",
    "noResults": "No enrolments match these filters.",
    "view": "View",
    "viewLabel": "View {name} — {title}",
    "results": "{count} active enrolments",
    "pages": "Enrolment pages",
    "previous": "Previous",
    "next": "Next",
    "page": "Page {page} of {total}"
},
  polish: {
    "clubCurrency": "Club currency",
    "currencyHelp": "Currency is set by your club.",
    "currencyLoading": "Loading currency…",
    "currencyUnavailable": "Currency unavailable",
    "deleteWorkshopTitle": "Delete workshop?",
    "deleteRunTitle": "Delete run?",
    "workshopScope": "This removes the unused workshop, its versions and its runs.",
    "runScope": "This removes only this unused run. The workshop and other runs are retained.",
    "eligible": "Eligible for deletion",
    "blocked": "Cannot delete",
    "irreversible": "This cannot be undone.",
    "keepWorkshop": "Keep workshop",
    "keepRun": "Keep run",
    "checkAgain": "Check again",
    "deleting": "Deleting… Waiting for server confirmation.",
    "uncertain": "Deletion result is not yet confirmed.",
    "retryOriginal": "Retry the original command to check its result safely.",
    "retryDelete": "Retry deletion",
    "versionsOne": "Version",
    "versionsMany": "Versions",
    "runsOne": "Run",
    "runsMany": "Runs",
    "sessionsOne": "Session",
    "sessionsMany": "Sessions",
    "instructorsOne": "Instructor link",
    "instructorsMany": "Instructor links",
    "reservationsOne": "Reservation",
    "reservationsMany": "Reservations"
},

  library: {"runOne": "{count} run","home": "Academy home", "back": "Back to workshops", "all": "All workshops", "current": "Current", "archived": "Archived or historical", "showing": "Showing {count} of {total} workshops", "runs": "{count} runs", "open": "Open", "actions": "Actions for {title}", "details": "Workshop details", "sort": "Sort workshops", "byTitle": "Title A–Z", "newest": "Newest first", "clear": "Clear filters", "pagination": "Workshop pages", "previous": "Previous", "next": "Next", "page": "Page {page} of {total}", "deleteWorkshop": "Delete workshop", "deleteRun": "Delete run", "confirmWorkshop": "Delete “{title}”? This removes the reusable workshop, {versions} versions and {runs} runs, only if unused.", "confirmRun": "Delete this run of “{title}”? The reusable workshop and other runs will remain.", "deleteProtection": "Participation, requests, assignments, policies, finance and learning history prevent deletion. Nothing is removed if a dependency is found.", "removal": "{sessions} sessions, {instructors} setup instructor links and {reservations} facility reservations will be removed or released.", "deleted": "Deleted successfully.", "linkedContext": "Linked run details · outside the current list filters.", "checking": "Checking deletion eligibility…"},
  guided: {
    unusualAcknowledgement: "Confirm the unusual session times before continuing.",
    "staffBookingSettings": "Paid staff booking settings",
    "instructor": "Instructor",
    "whenWhere": "When and where",
    "places": "Places",
    "review": "Review and publish",
    "completed": "Completed",
    "current": "Current step",
    "remaining": "To do",
    "runMeaning": "A workshop run is a scheduled delivery of this workshop.",
    "staffAfterPublish": "Choose the staff attending after you publish the workshop run.",
    "instructorHelp": "Choose who will deliver the workshop. Saved instructors stay assigned.",
    "chooseInstructor": "Choose an instructor to continue.",
    "savedInstructors": "Assigned instructors",
    "savedInstructor": "Saved instructor",
    "noInstructors": "No eligible instructors are available. Ask your club administrator to check Staff access.",
    "savedSchedule": "These sessions are saved. Edit each session separately to preserve the rest of the schedule and its history.",
    "maximum": "Maximum attendees",
    "placesHelp": "This is the maximum number of attendees, not a list of selected staff. Your saved number is already filled in.",
    "publish": "Publish workshop run",
    "next": "Next: {step}",
    "back": "Back",
    "savedRefreshFailed": "Saved successfully, but the latest view could not be loaded. Refresh to check the saved result; do not submit it again.",
    "scheduleMissing": "Save a future session before publishing.",
    "draftLabel": "Draft run · not scheduled",
    "publishedSummary": "Published workshop run",
    "manageBookings": "Manage bookings",
    "frequency": "Schedule",
    "one_off": "One-off",
    "repeating": "Repeating",
    "date": "Date",
    "hour": "Hour",
    "minute": "Minute",
    "period": "AM/PM",
    "sessions": "Number of weekly sessions",
    "repeatPreview": "Every {day}, {start}–{end}, for {count} sessions.",
    "onePreview": "{start}–{end}.",
    "sessionCount": "Sessions: {count}",
    "location": "Location / meeting point",
    "locationExamples": "Reception, Training room upstairs, or Meet by the main entrance",
    "meetingPointHelp": "Enter a meeting point inside or outside the club. This alone does not reserve a room.",
    "reserve": "Reserve a club space",
    "clubSpace": "Club space to reserve (optional)",
    "reservationHelp": "The selected club space will be reserved when you save. Availability and capacity are checked for every session.",
    "attendees": "{count} attendees",
    "reserved": "Club space reserved",
    "notReserved": "Meeting point only · no room reserved",
    "endAfterStart": "End time must be after start time.",
    "saveFailed": "Unable to save. Your entries have been kept.",
    "emptyHistory": "No booking or finance history for this run yet."
},
  publishedState: 'Published',
  backToDetails: 'Back to workshop details',
  unpublishedChanges: "Unpublished changes",
  publishDetails: "Publish workshop details",
  publishChanges: "Publish changes",
  currentPublishedVersion: "Current published version {number}",
  fixedRunVersion: "Existing workshop runs keep their original fixed version.",
  alreadyPublished: "These workshop details are already published. No new version was created.",
  detailsPublished: "Workshop details published. You can now schedule a workshop run.",
  runPublished: "Workshop run published. You can now view the workshop or assign staff.",
  createAnotherRun: "Create another run",
  openRun: "Open/manage run",
  maximumPlaces: "Maximum attendees",
  maximumPlacesHelp: "10 means ten available places, not ten selected employees. Staff are assigned after the run is published.",
  notScheduled: "Not yet scheduled",
  runSetup: "Workshop run setup",
  detailsStep: "Published workshop details selected",
  instructorStep: "Assign an instructor",
  scheduleStep: "Set date, time and location; check resources",
  reviewRunStep: "Review and publish the run",
  setupSaved: "Saved",
  setupPending: "Pending",
  savedProgress: "This draft run is saved. Retry the remaining step here; do not create another run to recover.",
  nextInstructor: "Next: assign an instructor, then schedule a session.",
  nextSchedule: "Next: schedule the session and choose its location or resource.",
  nextReviewSchedule: "Check the future dates, assigned instructor and meeting point. Real space reservations are checked separately.",
  nextPublish: "Ready for publication review. Publishing checks the current instructors and resources again.",
  assignStaff: "Assign staff",
  staffScopeHandoff: "Staff training previews only employees you are authorised to manage. Ask the appropriate team manager to assign anyone outside your scope. Paid runs require the existing authorised finance booking.",
  runCreated: "Draft workshop run saved. Continue the guided setup below.",
  createRunHelp: "Save a draft run, then choose an instructor, schedule it, confirm places and publish.",

  visual: {"searchResources":"Search learning resources","resources":"Learning resources","resourceHelp":"Learning resources are maintained by the club. Editing is unavailable in this catalogue.","resourceFallback":"No description has been provided. Ask your Academy team about this resource before starting.","available":"Active resource","unavailable":"Inactive resource","minutes":"min","durationUnknown":"Duration not provided","noResources":"No learning resources yet","lessons": {"title": "Build skills. Create experiences.", "intro": "Create reusable workshops, publish their details and schedule dated runs."}, "camps": {"title": "Camps & programmes", "intro": "Plan delivery, organise instructors and manage programme participation."}, "elearning": {"title": "Learning at your own pace", "intro": "Explore the club’s learning resources. Resource availability depends on its source."}, "instructors": {"title": "Meet your delivery team", "intro": "Find eligible staff and see who is assigned to deliver Academy programmes."}, "instructor-view": {"title": "Your teaching schedule", "intro": "Assigned sessions appear here. Open a roster to record attendance or review corrections."}, "createSession": "Create workshop", "createProgramme": "Create programme", "search": "Search Academy", "searchInstructors": "Search instructors", "records": "Record view", "current": "Current", "history": "Historical · read only", "assigned": "Assigned instructor", "eligible": "Eligible staff", "noInstructors": "No instructors to display", "library": "Workshops", "reusable": "Reusable workshops", "emptyTitle": "Create your first workshop", "emptyHelp": "Create a reusable workshop, publish its details, then schedule a run with an instructor.", "noResults": "No matching workshops", "adjustSearch": "Try a different search or switch the record view."},
  title: "Workshop workspace",
  intro:
    "Create, publish, schedule and deliver free workshops for members and employees.",
  overview: "Overview",
  definitions: "Definitions",
  offerings: "Workshop runs",
  roster: "Roster & attendance",
  legacy: "Legacy Academy history (read only)",
  freeOnly:
    "Free workshops can be booked without payment. Paid workshops use the club’s authorised booking and payment process.",
  attendanceOnly:
    "Attendance records participation. It does not issue completion, awards or accreditation.",
  loading: "Loading Academy…",
  retry: "Retry",
  error: "Unable to complete this action. Please retry.",
  denied: "You do not have permission to use this Academy workspace.",
  saved: "Saved successfully.",
  pending: "Saving…",
  refresh: "Refresh",
  create: "Create workshop",
  edit: "Edit draft",
  publish: "Publish version",
  published: "Published version",
  version: "Version {number}",
  createOffering: "Schedule workshop",
  publishOffering: "Publish workshop run",
  capacity: "Maximum attendees",
  occupied: "{count} of {capacity} places committed",
  empty: "No workshops yet. Create a definition to get started.",
  emptyAssigned: "No workshops are assigned to you.",
  attention: "Setup attention",
  ready: "Ready to deliver",
  upcoming: "Upcoming workshops",
  titleLabel: "Workshop title",
  description: "Description",
  audience: "Audience",
  members: "Members",
  staff: "Employees",
  both: "Members and employees",
  delivery: "Delivery",
  in_person: "Instructor-led workshop",
  online: "Online (future)",
  blended: "Blended (future)",
  price: "Price",
  free: "Free",
  paid: "Paid enrolment unavailable",
  save: "Save",
  cancel: "Cancel",
  close: "Close",
  archive: "Archive",
  closeBooking: "Close enrolment",
  cancelOffering: "Cancel workshop run",
  confirmCancel: "Cancel this workshop run and all its active enrolments?",
  offering: "Workshop run",
  schedule: "Schedule workshop",
  assign: "Assign instructor",
  instructor: "Instructor",
  select: "Choose…",
  start: "Start (club local time)",
  end: "End (club local time)",
  weeks: "Weekly occurrences (1–52)",
  timezone:
    "Times use {timezone}. Ambiguous daylight-saving times must be changed.",
  location: "Location",
  club_space: "Dedicated workshop space",
  off_site: "Off-site location",
  space: "Workshop space",
  spaceName: "Space name",
  spaceSetup: "Add dedicated workshop space",
  spaceHelp:
    "Use a dedicated shared workshop space. Existing sport, spa and accommodation resources require their owning booking module.",
  locationLabel: "Off-site venue",
  enrol: "Enrol a learner",
  search: "Search members and employees",
  learner: "Learner",
  eligible:
    "Select an active member or employee. Email does not establish identity.",
  enrolments: "Participants",
  noEnrolments: "No attendees yet.",
  noPeople: "No eligible people found.",
  enrolled: "Confirmed",
  cancelled: "Cancelled",
  rejoin: "Rejoin with a new enrolment",
  cancelEnrolment: "Cancel enrolment",
  occurrences: "Sessions",
  selectedOccurrences: "Selected sessions",
  allOccurrences: "All scheduled sessions",
  noOccurrences:
    "No sessions scheduled yet.",
  openRoster: "Open roster",
  noRoster: "No entitled learners for this occurrence.",
  attendance: "Attendance",
  unrecorded: "Not recorded",
  present: "Present",
  absent: "Absent",
  late: "Late",
  excused: "Excused",
  record: "Record attendance",
  reason: "Correction / identity-link reason",
  correctionReason: "Reason for change",
  correction: "Edit attendance",
  editParticipant: "Edit attendance for {name}",
  draftAttendance: "New attendance status",
  saveChanges: "Save changes",
  backToRegister: "Back to register",
  attendanceReadOnly: "Attendance is read-only under the current access or session rules.",
  otherStatusesStart: "Other attendance statuses become available when the session starts.",
  deliver: "Mark delivered",
  scheduled: "Scheduled",
  delivered: "Delivered",
  draft: "Draft",
  closed: "Closed",
  archived: "Archived",
  reschedule: "Reschedule",
  cancelOccurrence: "Cancel session",
  bind: "Link another role to this person",
  linkHelp:
    "Explicitly link a reviewed member/staff record to the selected learner. Existing conflicting bindings cannot be merged.",
  confirm: "Confirm",
  setupCount: "{count} offerings need a schedule or publication.",
  attendanceHistory: "Attendance history",
  historyIntro:
    "Original records and corrections remain available after enrolment cancellation. Cancelled learners do not return to the active roster.",
  historyLoading: "Loading attendance history…",
  noHistory: "No attendance has been recorded for this occurrence.",
  historyOriginal: "Initial attendance",
  historyCorrection: "Attendance changed",
  historyWhen: "Recorded at",
  historyActor: "Recorded by",
  historyStaff: "Club staff",
  historyPrevious: "Previous status",
  historyNew: "New status",
  historyUnrecorded: "Not recorded",
  historyMore: "Load more history",
  historyLocked:
    "This occurrence has started or has attendance evidence. Routine rescheduling and cancellation are unavailable.",
  errors: {
    currency_unconfigured: "Verify the club currency before saving a paid workshop.",
    currency_precision_unavailable: "Paid booking does not yet support this currency precision.",
"delete_enrolments":"This record has enrolment history, including cancelled or expired enrolments. Cancel or archive instead.",
"delete_assignments":"Staff learning assignments reference this record. Preserve their history and cancel or archive instead.",
"delete_requests":"A staff request references this run. Preserve the request history and cancel or archive instead.",
"delete_attendance":"Attendance or participant session selections reference this record. Preserve the learning history and archive instead.",
"delete_waiting":"Waiting-list history references this run. Cancel or archive instead.",
"delete_finance":"Booking and financial orders reference this run. Preserve the financial history and cancel or archive instead.",

"linked_record_unavailable":"This linked record is unavailable or has been deleted. Return to workshops.",
"delete_participation":"This record has enrolments, staff assignments, requests or participation history. Cancel the run or archive the workshop instead.",
"delete_reference":"A pathway, training policy or assignment preview references this record. Preserve it and archive instead.",
"delete_history":"Delivered sessions are learning history and cannot be deleted. Archive instead.",
"delete_policy":"Published booking policies reference this run. Preserve the policy history and cancel or archive instead.",
"academy_deletion_schema_unready":'Workshop deletion is temporarily unavailable because this club’s database needs an Academy schema check. Ask your administrator to check tenant migration status and the workshop version guard, then try again. Your workshop has not been deleted.',
"delete_dependency":"This record is referenced by booking, finance or evidence records and cannot be deleted. Cancel or archive instead.",
"delete_preview_changed":"The workshop changed after the deletion check. Close this dialog and review deletion again.",

    not_authenticated: "Your session is invalid. Sign in again.",
    authentication_unconfigured:
      "Authentication is unavailable. Contact your club administrator.",
    forbidden: "You do not have permission for this action.",
    academy_access_failed: "Club access could not be verified.",
    invalid_payload: "Check the required workshop fields.",
    invalid_id: "Choose a valid record.",
    tenant_override_forbidden: "The request contains an invalid club override.",
    learner_ineligible:
      "The selected person is inactive or outside this workshop’s audience.",
    binding_conflict:
      "This record is already linked to another person. Request an authorised identity review.",
    binding_or_enrolment_conflict:
      "This person or enrolment already exists. Refresh and review the current state.",
    instructor_not_assigned:
      "This instructor is not authorised for this workshop.",
    offering_full: "The offering is full.",
    occurrence_full: "A selected occurrence is full.",
    already_enrolled: "This learner already has an active enrolment.",
    idempotency_conflict:
      "This submission key was used for a different action. Refresh before submitting again.",
    request_key_required:
      "The submission could not be identified. Refresh and retry.",
    stale_revision: "Another user changed this record. Refresh before saving.",
    paid_enrolment_unavailable:
      "Paid enrolment is unavailable until financial booking is implemented.",
    schedule_conflict:
      "The instructor or workshop space is already booked. No occurrences from this submission were created.",
    facility_unavailable: "The workshop space is unavailable.",
    facility_capacity: "The workshop space cannot hold this many learners.",
    capacity_below_occupancy:
      "Capacity cannot be reduced below committed places or occurrence limits.",
    invalid_capacity: "Enter a valid positive capacity.",
    invalid_local_time:
      "Enter a valid local start and end time. This time may not exist due to daylight saving.",
    ambiguous_local_time:
      "This time occurs twice due to daylight saving. Choose an unambiguous time.",
    invalid_transition: "This action is unavailable in the current state.",
    offering_not_ready:
      "Schedule a future occurrence with an authorised instructor before opening enrolment.",
    schedule_locked_by_enrolments:
      "New occurrences cannot be added after enrolment. Create another offering.",
    delivery_not_available: "P1 publishes instructor-led workshops only.",
    club_timezone_required: "Configure the club timezone before scheduling.",
    legacy_academy_read_only:
      "Legacy Academy records are read only. Create a new workshop in the workspace.",
    invalid_occurrence_selection:
      "Choose at least one valid scheduled occurrence.",
    booking_closed: "Booking has closed for a selected occurrence.",
    cross_tenant_reference: "A selected record does not belong to this club.",
    not_entitled: "This learner is not entitled to attend this occurrence.",
    invalid_attendance: "Choose a valid attendance state.",
    occurrence_history_locked:
      "This occurrence has started or has attendance evidence. Routine rescheduling and cancellation are unavailable.",
    occurrence_future_required:
      "Choose a future start time for scheduling or rescheduling.",
    occurrence_not_started:
      "Attendance can be recorded once the occurrence starts.",
    reason_required: "Enter a reason for this correction or identity decision.",
    location_required: "Enter the off-site venue.",
    facility_required:
      "Choose a dedicated workshop space or an explicit off-site venue.",
    invalid_recurrence: "Choose between 1 and 52 weekly occurrences.",
    invalid_audience: "Choose a valid audience.",
    invalid_delivery: "Choose a valid delivery mode.",
    invalid_price: "Enter a non-negative price.",
    active_enrolments: "Cancel active enrolments before archiving.",
    not_found: "This record is unavailable. Refresh the workspace.",
    server_error:
      "Unable to complete the action. Retry with the same submission.",
    unknown_action: "This action is unavailable.",
  },
  permissions: {
    staff: { enrol: "Enrol canonical employees through the explicit Staff scope" },
    finance: { charge: "Charge Academy payments and member accounts", refund: "Issue Academy credits and refunds", reconcile: "Review and reconcile Academy payments" },
    offerings: {
      read: "Read workshop configuration",
      manage: "Manage definitions, scheduling and instructors",
      publish: "Publish workshop versions and offerings",
    },
    enrolments: {
      read: "Read club enrolments and rosters",
      manage: "Enrol and cancel learners",
    },
    identities: { manage: "Manage explicit dual-role identity links" },
    rosters: { read: "Read authorised rosters" },
    attendance: {
      record: "Record authorised attendance",
      history: { read: "Read authorised attendance history" },
    },
    instructor: { assigned: "Access only assigned instructor workshops" },
  },
  ...{"routes": {"lessons": {"title": "Workshops", "intro": "Reusable sessions for your Academy. Publish a version, then schedule a programme in Camps & Programmes."}, "camps": {"title": "Camps & Programmes", "intro": "Schedule programmes and manage participants, booking settings and delivery."}, "instructors": {"title": "Instructors", "intro": "Authoritative staff identities and their upcoming teaching assignments."}, "instructor-view": {"title": "Instructor View", "intro": "Your assigned sessions, participant rosters and attendance evidence."}}, "searchLibrary": "Search workshops", "allAudiences": "All audiences", "records": "Record view", "activeRecords": "Current records", "historicalRecords": "Historical records", "historicalGuidance": "Historical records are read only. Linked records retain their canonical identity; historical learning progress is not completion or accreditation.", "assignmentContext": "Upcoming assigned sessions", "emptyDirectory": "No instructors are available to this viewer.", "createProgramme": "Create programme", "minutes": "minutes", "learningAvailability": "Existing learning links remain available. Course editing, assessments and certificates are unavailable in this release.", "freeOnly": "Free booking is supported. Account and cash methods follow booking settings and authority. Card checkout requires a configured payment provider.", "paid": "Paid booking", "memberPresentation": "Member presentation", "eligibilityConsent": "Eligibility and consent", "paymentMethods": "Payment methods", "cancellationPolicy": "Cancellation and refunds", "advancedMapping": "Advanced accounting configuration"},
...{"statusFilter": "Status", "allStatuses": "All statuses", "categoryFilter": "Category", "allCategories": "All categories", "dateFrom": "From date", "dateTo": "To date", "profileAssignments": "Profile and assignments", "offeringSections": "Programme sections", "scheduleSection": "Schedule", "participantsSection": "Participants", "bookingSettings": "Booking settings", "financeHistory": "History and finance", "confirmedPlaces": "Confirmed places", "activeHolds": "Active holds", "waitingDemand": "Waiting participants", "lookupUnavailable": "Accounting lookups are unavailable for this viewer. Existing mappings are preserved."},
};
